import { useState } from "react"

import {
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	OutlinedInput
} from "@mui/material"

import useNotification from "../../../Notification/index.js"
import api from "../../../../api.js"

const WEEKDAYS = [
	{ value: 0, name: "Segunda" },
	{ value: 1, name: "Terça"   },
	{ value: 2, name: "Quarta"  },
	{ value: 3, name: "Quinta"  },
	{ value: 4, name: "Sexta"   },
	{ value: 5, name: "Sábado"  },
	{ value: 6, name: "Domingo" }
]

export default function ServiceTimeDialog({ data, setEmails, enterpriseId, handleClose }) {
	const [startTime, setStartTime] = useState(data?.start_time || "09:00")
	const [endTime, setEndTime] = useState(data?.end_time || "18:00")
	const [weekdays, setWeekdays] = useState(data?.weekdays || [0, 1, 2, 3, 4])

	const handleSave = async () => {
		const response = await api.patch(`/api/enterprises/${enterpriseId}/email/${data.id}/`, {
			regular_update: true,
			start_time: startTime,
			end_time: endTime,
			weekdays: weekdays
		})
		if (response.status === 200) {
			setEmails((prevState) => prevState.map((email) => email.id === response.data.id ? response.data : email))
			useNotification(
				"Sucesso",
				"Horário de atendimento atualizado com sucesso",
				"success"
			)
			handleClose()
			return
		}
		useNotification(
			"Ops!",
			"Algo deu errado, tente novamente.",
			"danger"
		)
	}

	return (
		<Dialog open={true} onClose={handleClose}>
			<DialogTitle>Horário de Atendimento</DialogTitle>
			<DialogContent>
				<Box mt={1}>
					<FormControl size="small" fullWidth>
						<InputLabel>Dias da Semana</InputLabel>
						<Select multiple
							value={weekdays}
							onChange={(event) => setWeekdays(event.target.value)}
							input={<OutlinedInput label="Dias da Semana" />}
						>
							{WEEKDAYS.map((item) => (
								<MenuItem key={item.value} value={item.value}>
									{item.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
				<Box display="flex" gap={1} flexDirection="row">
					<TextField
						label="Início"
						type="time"
						value={startTime}
						onChange={(e) => setStartTime(e.target.value)}
						fullWidth
						margin="normal"
						InputLabelProps={{ shrink: true }}
						inputProps={{ step: 300 }}
						size="small"
					/>
					<TextField
						label="Fim"
						type="time"
						value={endTime}
						onChange={(e) => setEndTime(e.target.value)}
						fullWidth
						margin="normal"
						InputLabelProps={{ shrink: true }}
						inputProps={{ step: 300 }}
						size="small"
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Box display="flex" gap={1} pb={1} pr={2}>
					<Button onClick={handleClose}>Cancelar</Button>
					<Button variant="contained" onClick={handleSave}>
						Salvar
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	)
}
